import { HttpResourceRef } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IApiErrorResponse, IWidgetComunicazioniRenderWidgetResponse } from '@core/models';
import { ApiService } from '@core/services/api/api.service';
import { Console } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class WidgetComunicazioniService {
  private readonly log_label = 'WidgetComunicazioniService';
  private readonly apiService = inject(ApiService);

  /**
   * Resource reattiva per il widget comunicazioni (Angular 22 `httpResource`).
   */
  createRenderWidgetResource(
    shouldLoad: () => boolean
  ): HttpResourceRef<IWidgetComunicazioniRenderWidgetResponse> {
    return this.apiService.getResource<IWidgetComunicazioniRenderWidgetResponse>(
      () => (shouldLoad() ? 'user/comunicazioni/render-widget' : undefined),
      undefined,
      {
        defaultValue: { success: false, html: '', count: 0 },
        debugName: 'widgetComunicazioni'
      }
    );
  }

  renderWidget(): Observable<IWidgetComunicazioniRenderWidgetResponse> {
    const log_pref = this.log_label + '.renderWidget() ';
    return this.apiService
      .get<IWidgetComunicazioniRenderWidgetResponse>('user/comunicazioni/render-widget')
      .pipe(
        catchError((error: IApiErrorResponse) => {
          const errorMessage =
            log_pref + (error?.message || 'Errore durante il render del widget comunicazioni.');
          Console.log(errorMessage, error, 'err');
          return throwError(() => error);
        })
      );
  }
}
